import { NotificationContainer } from "react-notifications";

const AuthFooter = () => (
  <footer
    style={{
      padding: "24px 32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 16,
      flexWrap: "wrap",
      color: "rgba(255,255,255,0.55)",
      fontSize: 13,
    }}
  >
    <div>
      © {new Date().getFullYear()}{" "}
      <a
        href="https://www.tenstep.tn/formation/"
        rel="noopener noreferrer"
        target="_blank"
        style={{ color: "rgba(255,255,255,0.85)", fontWeight: 600, textDecoration: "none" }}
      >
        TenStep
      </a>
      <span style={{ marginLeft: 8 }}>· StockPos</span>
    </div>
    <nav style={{ display: "flex", gap: 18 }}>
      {["TenStep", "About", "Blog", "License"].map((l) => (
        <a
          key={l}
          href="#"
          onClick={(e) => e.preventDefault()}
          style={{ color: "rgba(255,255,255,0.55)", textDecoration: "none" }}
        >
          {l}
        </a>
      ))}
    </nav>
    <NotificationContainer />
  </footer>
);

export default AuthFooter;
